import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@polyai/stream/store';
import { translationsSelectors } from '@polyai/stream/store/reducers/translations';

const selectTranslationSlice = (rootState: RootState) => rootState.translations;

export const selectAllTranslations = createSelector(
  [selectTranslationSlice],
  ({ translations }) => translationsSelectors.selectAll(translations),
);

export const selectTranslationById = createSelector(
  [selectTranslationSlice, (_state: RootState, id: string) => id],
  ({ translations }, id) => {
    if (!translations || !id) {
      return undefined;
    }

    return translationsSelectors.selectById(translations, id);
  },
);

export const selectTranslationByTranslationKey = createSelector(
  [
    selectTranslationSlice,
    (_state: RootState, translationKey: string) => translationKey,
  ],
  ({ translations }, translationKey) => {
    return translationsSelectors
      .selectAll(translations)
      .find(tn => tn.translationKey === translationKey);
  },
);
